
export const principles = {
  title: "Our Principles",
  subtitle: "The fundamental pillars of our active pedagogy",
  bookVisit: "Schedule a visit",
  items: {
    environment: {
      title: "Prepared Environments",
      description: "We create safe spaces where children can develop their learning with confidence and autonomy."
    },
    respect: {
      title: "Respectful Accompaniment",
      description: "We use non-violent communication and active listening to accompany each child's development."
    },
    learning: {
      title: "Active Learning",
      description: "Children are protagonists of their learning, discovering and experimenting by themselves."
    },
    international: {
      title: "Bilingual Education",
      description: "Our students achieve complete fluency in English and Spanish through daily immersion and expert guidance."
    },
    attention: {
      title: "Individualized Attention",
      description: "We maintain a teacher-student ratio that allows us to address individual needs."
    },
    development: {
      title: "Integral Development",
      description: "We promote the emotional, social, and intellectual development of each child."
    }
  }
};
